/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import UserFormPage from './UserFormPage'
import UserListPage from './UserListPage'

export const userRoutes: RouteObject[] = [
  {
    index: true,
    element: <UserListPage />
  },
  {
    path: 'create',
    element: <UserFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <UserFormPage />
      }
    ]
  }
]
